import React, { FC, useMemo } from 'react'
import { CMSStaticSection } from './../../../models'
import { JAdvertisement, JPageHeader, JProjectIntro, JSectionBanner, JSplitted, JCMSBanner } from '../../../JBanner/components'

export interface JCMSStaticBannerProps extends CMSStaticSection.Banner { }

export const JCMSStaticBanner: FC<JCMSStaticBannerProps> = props => {
    if (!props.enabled) return <></>
    const BannerComponent = useMemo(() => {
        const type = props.options?.type
        if (props.options?.type) {
            switch (type) {
                case 'PAGE_HEADER':
                    return JPageHeader
                case 'PROJECT_INTRO':
                    return JProjectIntro
                case 'SPLITTED':
                    return JSplitted
                case 'SECTION':
                    return JSectionBanner
                case 'ADVERTISEMENT':
                    return JAdvertisement
                default:
                    return JCMSBanner
            }
        }
        return JAdvertisement
    }, [props.options?.type])
    return (
        <BannerComponent {...props} />
    )
}